<template>
  <button
    class="boost-facet__value"
    :class="{ 'boost-facet__value-color': isColor }"
    tabindex="-1"
    type="button"
    :data-filter-id="facet.filterOptionId"
    :js-boost-facet="selector"
  >
    <div
      v-if="!isColor"
      class="boost-facet__checkbox"
    >
      <icon-tick />
    </div>

    <div
      v-if="isColor"
      class="boost-facet__swatch"
      :class="{ 'boost-facet__swatch--white': isWhite }"
      :style="{ backgroundImage: getSwatchImage() }"
    />

    <div class="boost-facet-value__text-wrapper">
      <div
        class="boost-facet__value--key"
        :class="{ 'size-value': facet.filterOptionId.includes('pf_opt_size') }"
        v-text="formatTitle()"
      />
    </div>
  </button>
</template>

<script>

/**
 * Vue: Boost facet value (boost-facet-value)
 * -----------------------------------------------------------------------------
 * Individual value shown in mobile and desktop facets.
 *
 * @param {Object} facet - Component facet.
 * @param {String} selector - JS attribute selector.
 * @param {Object} value - Facet value.
 *
 */
import IconTick from '~icons/misc/tick.svg'

export default {
  name: 'BoostFacetValue',

  components: {
    IconTick,
  },

  props: {
    facet: {
      type: Object,
      default: null,
    },
    selector: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: null,
    },
  },

  computed: {

    /**
     * Compute if value is a color.
     */
    isColor() {
      return this.facet.filterOptionId === 'pf_opt_color'
    },

    /**
     * Compute key for value. Different value types use different key names.
     */
    valueKey() {
      return this.value.tag ? this.value.tag : this.value.key
    },

    /**
     * Compute if value is white.
     */
    isWhite() {
      return this.valueKey.toLowerCase().includes('white')
    },
  },

  methods: {

    /**
     * Get swatch image based on value key.
     * @returns {String}
     */
    getSwatchImage() {
      if (!window.cnvs.filterSwatches || !window.cnvs.urls) {
        return null
      }

      const handle = this.valueKey.toLowerCase().split(' ').join('-').split('/').join('')
      const found = window.cnvs.filterSwatches.find((swatch) => swatch.key === handle)

      if (!found) {
        return null
      }

      const url = window.cnvs.urls.files.replace('placeholder', found.swatch)

      return `url(${url})`
    },

    /**
     * Format title for keys that include tag values.
     * @returns {String}
     */
    formatTitle() {
      let title = this.valueKey

      if (this.valueKey.includes(':')) {
        title = this.valueKey.split(':')[1]
      }

      return title
    },
  },
}
</script>
